/**
 * Trims string and replaces any instance of multiple spaces with one space
 */
export const removeMultipleSpaces = (value: string) =>
  value.trim().replace(/\s+/, ' ')

export const capitalizeFirstLetter = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}
